import { useRef, useMemo } from 'react'
import { ApolloProvider, initApolloClientSingleton } from 'vvs-gotchi-graphql'
import { useAppStore } from 'state'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import I18nDisabledProvider from 'contexts/Localization/DisabledProvider'

import AuthModalProvider from './AuthModal/ContextProvider'

const Providers: React.FC = ({ children }) => {
  return (
    <I18nDisabledProvider>
      <GotchiApolloProviderWithAuth>
        <AuthModalProvider>{children}</AuthModalProvider>
      </GotchiApolloProviderWithAuth>
    </I18nDisabledProvider>
  )
}

export default Providers

const GotchiApolloProviderWithAuth: React.FC = ({ children }) => {
  const store = useAppStore()
  const { account } = useActiveWeb3React()
  const accountRef = useRef(account)
  accountRef.current = account

  const client = useMemo(
    () =>
      initApolloClientSingleton({
        getUri: () => process.env.REACT_APP_VVSGOTCHI_GRAPHQL_ENDPOINT,
        getCurrentAccessToken: () => store.getState().vvsgotchi.accessToken[accountRef.current]?.token,
      }),
    [store],
  )

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
